// src/pages/VatTypesPage.jsx

import { useState, useEffect } from 'react';
import axios from '../../axios';
import API_BASE_URL from '../../config';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';

export default function VatTypesPage() {
  const companyId = parseInt(localStorage.getItem('companyId'), 10);

  const [vatTypes, setVatTypes] = useState([]);
  const [form, setForm] = useState({
    companyId,
    name: '',
    rate: 0  // المستخدم يدخل 15 → سنحوّله إلى 0.15
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    fetchVatTypes();
  }, [companyId]);

  const fetchVatTypes = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/VatTypes?companyId=${companyId}`
      );
      setVatTypes(res.data);
    } catch (err) {
      console.error('❌ خطأ تحميل أنواع الضريبة:', err);
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: name === 'rate' ? parseFloat(value) : value
    }));
  };

  const handleAdd = async () => {
    if (!form.name || form.rate <= 0) {
      return alert('❌ الرجاء إدخال اسم ونسبة ضريبة صحيحة.');
    }
    setLoading(true);
    try {
      // حول النسبة المئوية إلى عشرية قبل الإرسال
      const payload = {
        ...form,
        rate: form.rate / 100
      };
      await axios.post(`${API_BASE_URL}/VatTypes`, payload);
      setForm({ companyId, name: '', rate: 0 });
      fetchVatTypes();
    } catch (err) {
      console.error('❌ خطأ إضافة نوع ضريبة:', err.response?.data || err);
      alert(err.response?.data?.message || 'حدث خطأ أثناء الإضافة.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async id => {
    if (!window.confirm('❗ هل تريد حذف هذا النوع؟')) return;
    try {
      await axios.delete(`${API_BASE_URL}/VatTypes/${id}`);
      fetchVatTypes();
    } catch (err) {
      console.error('❌ خطأ حذف نوع ضريبة:', err);
      alert('حدث خطأ أثناء الحذف.');
    }
  };

  return (
    <Card className="max-w-4xl mx-auto mt-10 p-6 shadow-lg" dir="rtl">
      <CardContent>
        <h2 className="text-xl font-bold mb-4">📑 إدارة أنواع الضريبة</h2>

        {/* نموذج إضافة */}
        <div className="grid grid-cols-4 gap-4 mb-6">
          {/* حقل مخفي لـ companyId */}
          <Input type="hidden" name="companyId" value={form.companyId} />

          <Input
            name="name"
            placeholder="اسم الضريبة"
            value={form.name}
            onChange={handleChange}
            required
          />
          <Input
            name="rate"
            type="number"
            step="0.01"
            placeholder="النسبة (مثلاً 15 لـ15%)"
            value={form.rate}
            onChange={handleChange}
            required
          />
          <Button onClick={handleAdd} disabled={loading}>
            {loading ? 'جاري الإضافة...' : '➕ إضافة'}
          </Button>
        </div>

        {/* جدول عرض الأنواع */}
        <div className="overflow-x-auto">
          <table className="w-full table-auto border-collapse text-sm">
            <thead>
              <tr className="bg-gray-100 text-center">
                <th className="px-4 py-2 border">#</th>
                <th className="px-4 py-2 border">اسم الضريبة</th>
                <th className="px-4 py-2 border">النسبة (%)</th>
                <th className="px-4 py-2 border">إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {vatTypes.map((v, idx) => (
                <tr key={v.id} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-4 py-2 border text-center">{idx + 1}</td>
                  <td className="px-4 py-2 border">{v.name}</td>
                  <td className="px-4 py-2 border text-center">
                    {(v.rate * 100).toFixed(2)}
                  </td>
                  <td className="px-4 py-2 border text-center">
                    <Button
                      size="sm"
                      variant="destructive"
                      onClick={() => handleDelete(v.id)}
                    >
                      🗑️
                    </Button>
                  </td>
                </tr>
              ))}
              {vatTypes.length === 0 && (
                <tr>
                  <td colSpan="4" className="px-4 py-6 border text-center text-gray-500">
                    لا يوجد أنواع ضريبة
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
